import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../contexts/LanguageContext';

const ForgotPassword = () => {
  const { t } = useLanguage();
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    setLoading(true);

    try {
      await axios.post('/api/auth/forgot-password', { email });
      setMessage(t('If your email is registered with us, you will receive a password reset link.'));
      setEmail('');
    } catch (error) {
      console.error('Forgot password request failed:', error);
      // Always show the same message for security reasons
      setMessage(t('If your email is registered with us, you will receive a password reset link.'));
      setEmail('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1 className="login-title">{t('Reset Password')}</h1>
        
        {error && (
          <div className="alert alert-error">
            {error}
          </div>
        )}

        {message && (
          <div className="alert alert-success">
            {message}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email" className="form-label">
              {t('Email Address')}
            </label>
            <input
              type="email"
              id="email"
              className="form-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              placeholder={t('Enter your email address')}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary"
            style={{ width: '100%' }}
            disabled={loading || !email.trim()}
          >
            {loading ? t('Sending...') : t('Send Reset Link')}
          </button>
        </form>

        <div className="text-center mt-20">
          <Link 
            to="/login" 
            style={{ 
              color: 'var(--primary-blue)', 
              textDecoration: 'none',
              fontSize: '14px'
            }}
          >
            ← {t('Back to Login')}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
